import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { PAGE_LOADERS, pageNameFor } from "./routes";

async function start() {
  const initialPageName = pageNameFor(window.location.pathname);
  const { default: InitialPage } = await PAGE_LOADERS[initialPageName]();
  const content = (
    <App InitialPage={InitialPage} initialPageName={initialPageName} />
  );
  const container = document.getElementById("root");
  if (container.hasChildNodes()) hydrateRoot(container, content);
  else createRoot(container).render(content);
}
start().catch(() => {
  const root = document.getElementById("root");
  if (!root.hasChildNodes())
    root.innerHTML =
      '<main><h1>Thrivehaus Digital</h1><p>We could not load this page. Please refresh or <a href="https://www.instagram.com/thrivehausdigital">contact us on Instagram</a>.</p></main>';
});
